export const BLOG_CATEGORIES = [
  "State of the Industry",
  "Permitting 101",
  "AHJ Spotlight",
  "Careers & Workforce",
  "Tech & AI in Construction",
];

export const categorySlug = (c) =>
  (c || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const categoryFromSlug = (slug) =>
  BLOG_CATEGORIES.find((c) => categorySlug(c) === slug) || null;
